import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import { removeSavedJob } from '../../../actions/jobs';
import classes from './scss/savedJobs.module.scss';
import PaginationPanel from '../../common/PaginationPanel/PaginationPanel';
import RecommendedJobsList from '../../common/ListsOfComponents/RecommendedJobsList';
import JobCardSkeleton from '../../common/Skeletons/JobCardSkeleton';
import { actionTypes } from './types';
import SavedJobsList from '../../common/ListsOfComponents/SavedJobsList';

function SavedJobs(props) {
  const { jobsData, counter, recommendedJobs, searchParams, currentPage, setCurrentPage } = props;

  const pendingFetch = useSelector((state) => state.jobs.pendingFlag);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const pagination = useSelector((state) => state.jobs.pagination);

  const handleJobOptions = async (action, jobId) => {
    switch (action) {
      case actionTypes.VIEW:
        return navigate(`/dashboard/jobs/${jobId}`);
      case actionTypes.UNSAVE:
        dispatch(removeSavedJob(jobId));
        return true;
      case actionTypes.APPLY:
        localStorage.setItem(`OpenedJobId`, JSON.stringify(jobId));
        return navigate({
          pathname: '/dashboard/jobs',
          search: '?tab=saved&action=apply'
        });
      default:
        return null;
    }
  };

  return (
    <>
      <div className="row pt-5">
        <div className={`d-flex align-items-center flex-wrap ${classes.titleContainer}`}>
          <h1 className="d-inline align-middle text-nowrap">{t('profile.tabs.savedjobs')}</h1>
          {Array.isArray(jobsData) && (
            <Trans i18nKey="dashboard.jobs.foundjobs" counter={counter}>
              <span className="align-middle px-5">
                Found {{ counter }} job{counter > 1 ? 's' : ''}
              </span>
            </Trans>
          )}
        </div>
      </div>
      <div className="row w-100">
        <div className="col-md-12 pt-4 mb-5" style={{ gap: '19px' }}>
          <SavedJobsList jobsData={jobsData} pendingFetch={pendingFetch} handleJobOptions={handleJobOptions} />
          <div className={classes.pagination}>
            {Array.isArray(jobsData) && (
              <PaginationPanel total={pagination?.TotalPages} active={currentPage} setActive={setCurrentPage} />
            )}
          </div>
          <div className={`row pt-5 ${classes.recommended}`}>
            <div className="col-12">
              <h5>{t('profile.tabs.recommendedjobs')}</h5>
              {pendingFetch ? (
                <div className={classes.skeletonContainer}>
                  {Array.from({ length: 3 }, (v, k) => k).map((_, idx) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <JobCardSkeleton key={idx} />
                  ))}
                </div>
              ) : (
                <RecommendedJobsList jobsData={recommendedJobs} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SavedJobs;
